import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'student-ssid',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './student-ssid.component.html',
  styleUrl: './student-ssid.component.css'
})
export class StudentSsidComponent {

  @Output() onClose = new EventEmitter<void>();
  @Output() onSubmit = new EventEmitter<{student_identifier: string}>();

  studentSSIDForm = new FormGroup({
    studentSSID: new FormControl(null, Validators.required)
  })

  handleCloseStudentSSID(): void {
    this.onClose.emit();
  }

  submitStudentSSID(): void {
    if (this.studentSSIDForm.invalid) {
      return;
    } else {
      this.onSubmit.emit({student_identifier: this.studentSSIDForm.value.studentSSID!});
    }
  }
}
